// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"149":"47418a04","672":"12b8fe6d","816":"47418a04"}[chunkId] + ".css";
};